import 'core-js/modules/es6.reflect.construct';
import _classCallCheck from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _inherits from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
import _possibleConstructorReturn from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module indent/indentui
 */
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import indentIcon from '../theme/icons/indent.svg';
import outdentIcon from '../theme/icons/outdent.svg';
/**
 * The indent UI feature.
 *
 * This plugin registers the `'indent'` and `'outdent'` buttons.
 *
 * **Note**: In order for the commands to work, at least one of the compatible features is required. Read more in
 * the {@link module:indent/indent~Indent indent feature} API documentation.
 *
 * @extends module:core/plugin~Plugin
 */
var IndentUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(IndentUI, _Plugin);
    var _super = _createSuper(IndentUI);
    function IndentUI() {
        _classCallCheck(this, IndentUI);
        return _super.apply(this, arguments);
    }
    _createClass(IndentUI, [
        {
            key: 'init',
            value: /**
     * @inheritDoc
     */
            function init() {
                var editor = this.editor;
                var locale = editor.locale;
                var t = editor.t;
                var localizedIndentIcon = locale.uiLanguageDirection == 'ltr' ? indentIcon : outdentIcon;
                var localizedOutdentIcon = locale.uiLanguageDirection == 'ltr' ? outdentIcon : indentIcon;
                this._defineButton('indent', t('Increase indent'), localizedIndentIcon);
                this._defineButton('outdent', t('Decrease indent'), localizedOutdentIcon);
            }    /**
     * Defines a UI button.
     *
     * @param {String} commandName
     * @param {String} label
     * @param {String} icon
     * @private
     */
        },
        {
            key: '_defineButton',
            value: function _defineButton(commandName, label, icon) {
                var _this = this;
                var editor = this.editor;
                editor.ui.componentFactory.add(commandName, function (locale) {
                    var command = editor.commands.get(commandName);
                    var view = new ButtonView(locale);
                    view.set({
                        label: label,
                        icon: icon,
                        tooltip: true
                    });
                    view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
                    _this.listenTo(view, 'execute', function () {
                        return editor.execute(commandName);
                    });
                    return view;
                });
            }
        }
    ], [{
            key: 'pluginName',
            get: /**
     * @inheritDoc
     */
            function get() {
                return 'IndentUI';
            }
        }]);
    return IndentUI;
}(Plugin);
export {
    IndentUI as default
};